export default __webpack_public_path__ + "static/media/appliances.edbc6228.png";